<div class="activity-page">
  <div>Fetching activity...</div>
</div>
